import * as React from 'react';
import { CarousalConstants } from '../constants';
import { StyledCustomImageContainer, Image } from '../style';
/**
 *
 * @param props ICarouselItemTypeProps
 * @returns CustomImageView - component
 */
export const CustomImageView = (props) => {
    const { index, file, imageContainerWidth } = props.carouselViewProps;
    return (React.createElement(StyledCustomImageContainer, { id: `image-container-${index}`, width: `${imageContainerWidth}` || CarousalConstants.IMAGE_WIDTH_AUTO },
        React.createElement(Image, { id: `original-image-${index}`, src: file.url })));
};
//# sourceMappingURL=CustomImageView.js.map